var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManageMicrosite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56.849,
    height: 53.398,
    viewBox: "0 0 56.849 53.398",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32",
    "data-name": "Group 32",
    transform: "translate(463.064 250.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_31",
    "data-name": "Group 31",
    transform: "translate(-463.064 -250.837)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_813",
    "data-name": "Path 813",
    d: "M-419.4-203.923c0,1.779-.485,2.255-2.29,2.255h-35.95c-1.761,0-2.246-.476-2.246-2.2,0-8.487,0-21.349,0-29.836,0-.3.026-.6.044-.953H-419.4v2.487h4.152c0-5.244,0-7.434,0-12.678a5.807,5.807,0,0,0-.153-1.482,5.776,5.776,0,0,0-5.8-4.5c-8.33-.017-7.923,0-16.257-.009-8.3,0-12.228-.009-20.532,0a5.743,5.743,0,0,0-6.04,5.891c-.039,12.39-.035,29.15,0,41.539a5.755,5.755,0,0,0,6,5.948c16.638.017,20.16.017,36.793,0a5.8,5.8,0,0,0,6-6.04v-2.041H-419.4Zm-40.447-41.286a1.38,1.38,0,0,1,1.211-1.355,6.806,6.806,0,0,1,1.3-.1c16.166,0,19.22,0,35.39,0,2.1,0,2.544.433,2.544,2.509v5.253h-40.464C-459.862-241.044-459.893-243.125-459.845-245.209Z",
    transform: "translate(464.064 250.837)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_814",
    "data-name": "Path 814",
    d: "M-445.509-234.872a1.86,1.86,0,0,1-.538,1.346,1.86,1.86,0,0,1-1.341.551,1.919,1.919,0,0,1-1.865-1.836,1.92,1.92,0,0,1,1.851-1.939,1.851,1.851,0,0,1,1.346.536A1.85,1.85,0,0,1-445.509-234.872Z",
    transform: "translate(455.726 242.907)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_815",
    "data-name": "Path 815",
    d: "M-418.6-236.748a1.865,1.865,0,0,1,1.323.592,1.865,1.865,0,0,1,.5,1.36,1.872,1.872,0,0,1-1.865,1.822,1.943,1.943,0,0,1-1.9-1.909,1.942,1.942,0,0,1,1.938-1.865Z",
    transform: "translate(439.558 242.905)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_816",
    "data-name": "Path 816",
    d: "M-434.818-234.9a1.855,1.855,0,0,1,.569-1.33,1.855,1.855,0,0,1,1.351-.516,1.936,1.936,0,0,1,1.828,1.876,1.931,1.931,0,0,1-1.9,1.9,1.865,1.865,0,0,1-1.329-.575A1.865,1.865,0,0,1-434.818-234.9Z",
    transform: "translate(447.6 242.906)",
    fill: "#3067ae",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8229",
    "data-name": "Group 8229",
    transform: "translate(35.488 21.365)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8228",
    "data-name": "Group 8228"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16812",
    "data-name": "Path 16812",
    d: "M6032.777,1201.492c.714.209,1.418.41,2.119.624a.268.268,0,0,0,.326-.084c.145-.164.3-.319.462-.468a.249.249,0,0,0,.076-.3c-.192-.635-.369-1.276-.561-1.911a.232.232,0,0,1,.128-.318c.531-.3,1.058-.6,1.583-.906a.207.207,0,0,1,.295.039c.458.473.924.937,1.377,1.415a.3.3,0,0,0,.359.1,4.763,4.763,0,0,1,.563-.152.383.383,0,0,0,.321-.318c.155-.626.318-1.251.465-1.878.036-.149.089-.2.248-.2.627.011,1.254.009,1.881,0a.2.2,0,0,1,.238.185c.155.645.326,1.287.486,1.931a.31.31,0,0,0,.243.253c.249.063.494.142.746.192a.289.289,0,0,0,.214-.091c.476-.491.944-.988,1.414-1.484a1.271,1.271,0,0,0,.086-.115c.1.052.171.091.246.134.516.3,1.028.6,1.549.888a.224.224,0,0,1,.123.314c-.194.648-.376,1.3-.57,1.947a.223.223,0,0,0,.063.265c.174.162.343.331.5.505a.227.227,0,0,0,.267.062c.661-.2,1.323-.384,1.984-.582a.181.181,0,0,1,.252.1c.341.6.691,1.192,1,1.722-.286.318-.547.623-.825.912-.252.261-.519.509-.788.754a.223.223,0,0,0-.068.263c.065.222.126.446.177.672a.245.245,0,0,0,.214.216c.659.15,1.315.316,1.975.468.133.031.183.081.183.223q0,.959.024,1.918a.191.191,0,0,1-.176.228c-.675.167-1.346.347-2.021.515a.3.3,0,0,0-.254.258c-.05.238-.2.5-.151.7s.306.346.476.512c.381.371.764.742,1.151,1.108.1.09.125.156.049.282-.322.53-.634,1.066-.944,1.6a.192.192,0,0,1-.255.111c-.692-.2-1.388-.38-2.081-.579a.29.29,0,0,0-.332.075c-.488.483-.49.479-.308,1.142.148.537.289,1.077.441,1.613a.218.218,0,0,1-.124.288q-.8.455-1.594.923a.188.188,0,0,1-.273-.04c-.5-.524-1.017-1.04-1.52-1.565a.263.263,0,0,0-.31-.093,5.731,5.731,0,0,1-.58.154.219.219,0,0,0-.188.195c-.165.714-.342,1.426-.5,2.141-.034.156-.1.2-.25.194-.626-.016-1.254-.022-1.881-.023-.14,0-.192-.049-.225-.184-.165-.7-.348-1.4-.513-2.1a.269.269,0,0,0-.24-.237c-.238-.046-.5-.2-.7-.139s-.341.313-.507.483c-.372.381-.748.76-1.114,1.147a.227.227,0,0,1-.333.051q-.776-.462-1.564-.9a.224.224,0,0,1-.125-.3c.183-.651.352-1.306.542-1.955a.445.445,0,0,0-.1-.474c-.4-.451-.4-.449-.973-.288s-1.174.312-1.759.473a.181.181,0,0,1-.24-.1c-.312-.543-.627-1.085-.95-1.622a.171.171,0,0,1,.038-.254c.52-.491,1.03-.991,1.552-1.479a.265.265,0,0,0,.086-.309,5.718,5.718,0,0,1-.146-.583.27.27,0,0,0-.236-.242c-.683-.162-1.361-.341-2.043-.5-.135-.032-.18-.085-.177-.225q.025-.959.027-1.918c0-.143.052-.19.185-.221.659-.151,1.316-.315,1.975-.467a.234.234,0,0,0,.208-.2,6.407,6.407,0,0,1,.184-.651.233.233,0,0,0-.071-.279c-.51-.491-1.011-.992-1.522-1.482a.2.2,0,0,1-.037-.3C6032.089,1202.691,6032.423,1202.1,6032.777,1201.492Zm13.668,6.346a4.958,4.958,0,0,0-5.129-4.994,5,5,0,0,0,.158,10A4.891,4.891,0,0,0,6046.446,1207.838Z",
    transform: "translate(-6030.794 -1197.14)",
    fill: "#3067ae",
    fillRule: "evenodd"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1",
    "data-name": "Line 1",
    x2: 19.084,
    transform: "translate(-453.752 -227.454)",
    fill: "none",
    stroke: "#3067ae",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_2",
    "data-name": "Line 2",
    x2: 19.084,
    transform: "translate(-453.752 -221.336)",
    fill: "none",
    stroke: "#3067ae",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_3",
    "data-name": "Line 3",
    x2: 19.084,
    transform: "translate(-453.752 -215.217)",
    fill: "none",
    stroke: "#3067ae",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_4",
    "data-name": "Line 4",
    x2: 19.084,
    transform: "translate(-453.752 -209.099)",
    fill: "none",
    stroke: "#3067ae",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageMicrosite);
export default __webpack_public_path__ + "static/media/ManageMicrosite.e3468425542f10a16f6a4ff7db3a41c7.svg";
export { ForwardRef as ReactComponent };